import axios from "axios";
import settings from "../../../../utils/settings";

const url = `${settings.accountsUrl}api/admin/stories`;

export const deleteStories = (id) => {
  return axios.delete(`${url}/${id}`);
};



// WEBPACK FOOTER //
// ./src/views/pages/stories/requests/deleteStories.js